import React, { useState } from 'react';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';
import PreviewModal from './PreviewModal';

const PREVIEW_IMAGE = '/preview.png';
const PREVIEW_ALT = '简历匹配度评估报告预览';
const MAX_PREVIEW_HEIGHT = '600px';

const PreviewSection = () => {
  const [showModal, setShowModal] = useState(false);
  useBodyScrollLock(showModal);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            评估报告预览
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            查看实际的简历匹配度评估报告，了解我们的分析深度和专业性
          </p>
        </div>
        
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center">
            <p className="text-gray-600 mb-4">点击图片查看完整尺寸的评估报告</p>
            <PreviewThumbnail onClick={openModal} />
          </div>
        </div>
      </div>
      
      <PreviewModal 
        isOpen={showModal}
        onClose={closeModal}
        imageSrc={PREVIEW_IMAGE}
        alt={PREVIEW_ALT}
      />
    </section>
  );
};

const PreviewThumbnail = ({ onClick }) => (
  <div className="relative inline-block cursor-pointer group" onClick={onClick}>
    <img 
      src={PREVIEW_IMAGE}
      alt={PREVIEW_ALT}
      className="mx-auto rounded-lg shadow-md max-w-full h-auto transition-transform group-hover:scale-102"
      style={{ maxHeight: MAX_PREVIEW_HEIGHT }}
    />
    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-5 transition-all rounded-lg flex items-center justify-center">
      <div className="text-white opacity-0 group-hover:opacity-100 transition-opacity bg-black bg-opacity-60 px-4 py-2 rounded-lg">
        <div className="flex items-center space-x-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
          </svg>
          <span>点击查看完整尺寸</span>
        </div>
      </div>
    </div>
  </div>
);


export default PreviewSection;